import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { getScrappedPromoById } from '../../actions/admin/scrappedPromoAction';
import Constants from '../../common/constants';
import Post from '../post/post';

const ConvertPost = ({ match, getScrappedPromoById }) => {
  const [redirect, setRedirect] = useState(false);
  const [scrappedPromo, setScrappedPromo] = useState(null);
  const redirectUrl = `/admin/scrappedPromos`;

  useEffect(() => {
    getScrappedPromoById(match.params.scrappedPromoId)
      .then((data) => setScrappedPromo(data))
      .catch((err) => toast.error(err));
  }, []);

  const Highlighted = ({ text = '' }) => {
    const regex = /(… More|…More)/g;
    const parts = text.split(regex);
    return (
      <Typography
        variant="body1"
        style={{
          wordWrap: 'break-word',
        }}
      >
        {parts.filter((part) => part).map((part, i) => (
          (part === '… More' || part === '…More') ? (
            <mark
              style={{
                backgroundColor: Constants.Colours.Red,
                color:           Constants.Colours.White,
              }}
              key={i}
            >
              {part}
            </mark>
          ) : <span key={i}>{part}</span>
        ))}
      </Typography>
    );
  };

  if (redirect) {
    return <Redirect to={redirectUrl} />;
  }

  return (
    <>
      <div className="row" style={{}}>
        <div className="col-md-12" style={{ marginBottom: 100 }}>
          <Post pageId={match.params.pageId} match={match} redirectUrl={redirectUrl} />
        </div>
      </div>
      <div
        className="row"
        style={{
          overflow:        'auto',
          position:        'fixed',
          bottom:          0,
          left:            0,
          paddingLeft:     240,
          paddingTop:      10,
          paddingBottom:   10,
          width:           '100%',
          height:          100,
          backgroundColor: '#f8f8f8',
        }}
      >
        <div
          className="col-md-9"
          style={{
            marginTop: 5,
          }}
        >
          {scrappedPromo ? <Highlighted text={scrappedPromo.content} /> : ''}
        </div>
        <div className="col-md-3 d-flex align-items-start" style={{ justifyContent: 'center' }}>
          <Button onClick={() => setRedirect(true)} style={{ height: 80 }}>Back to Scrapped Posts</Button>
        </div>
      </div>
    </>
  );
};

ConvertPost.propTypes = {
  getScrappedPromoById: PropTypes.func.isRequired,
  match:                PropTypes.shape({
    params: PropTypes.shape({
      scrappedPromoId: PropTypes.string,
      pageId:          PropTypes.string,
    }),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

export default connect(mapStateToProps, { getScrappedPromoById })(ConvertPost);
